import { ContentSection, Heading, Text } from '@cinch-labs/design-system'
import { StoryBlokRichText, StoryblokImage } from '@cinch-nx/data-storyblok'
import Image from 'next/legacy/image'

import renderWithResolver from '../rich-text-renderer/rich-text-renderer'
import styles from './feature-image-card-section.module.css'

export interface FeatureImageCardSectionProps {
  title: string
  cards: FeatureImageCard[]
}

export interface FeatureImageCard {
  image: StoryblokImage
  iconTitle: string
  heading: string
  body: StoryBlokRichText
}

const FeatureImageCardSection: React.FC<FeatureImageCardSectionProps> = ({
  title,
  cards,
}) => (
  <section
    className={styles.container}
    data-testid="feature-image-card-section"
  >
    <div className={styles.innerContainer}>
      <Heading className={styles.title} fontSize="h1">
        {title}
      </Heading>

      <div className={styles.cardsWrapper}>
        {cards.map((card, index) => (
          <div key={card.heading + index} className={styles.singleCardWrapper}>
            <div className={styles.imageWrapper}>
              <Image
                src={card.image.filename}
                alt={card.image.alt ?? undefined}
                layout="fill"
                objectFit="cover"
              />
            </div>
            <Text className={styles.iconTitleText}>{card.iconTitle}</Text>
            <Heading className={styles.cardHeading}>{card.heading}</Heading>
            <ContentSection
              sectionWrapperClass={styles.sectionWrapper}
              classNames={{ body: styles.cardBody }}
            >
              {renderWithResolver(card.body)}
            </ContentSection>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default FeatureImageCardSection
